<template>
  <EcxToolbar
    :show-toggle="true"
    :sidebar-expanded="expanded"
    :show-profile="true"
    :show-profile-menu-items="false"
    :user-name="userName"
    :user-email="userEmail"
    :avatar-url="userAvatarUrl"
    @toggle="toggleSidebar"
    @logout="handleLogout"
    @settings="handleSettings"
  >
    <!-- Toggle icon customizado -->
    <template #toggle-icon>
      <DrawerToggleBlueIcon v-if="expanded" class="w-5 h-5" />
      <DrawerToggleGrayIcon v-else class="w-5 h-5 text-subtitle-gray" />
    </template>

    <!-- Ações à direita -->
    <template #right>
      <!-- Configuracoes: link comentado ate a pagina /configuracoes existir (reuso em breve).
      <RouterLink
        to="/configuracoes"
        class="h-10 w-10 flex items-center justify-center text-subtitle-gray hover:bg-grey-50 rounded-lg transition-colors"
      >
        <SettingsIcon class="w-5 h-5" />
      </RouterLink>
      -->
    </template>

  </EcxToolbar>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
// import { RouterLink } from 'vue-router' // reuse com /configuracoes
import { storeToRefs } from 'pinia'
// import { useI18n } from 'vue-i18n' // reuse com o label de /configuracoes

import { useSidebarStore } from '@/stores/sidebar'
import { useUserStore } from '@/stores/user'
import { useAuthStore } from '@/stores/auth'

import { EcxToolbar } from '@ecx/ui'
import {
  DrawerToggleBlueIcon,
  DrawerToggleGrayIcon,
  // SettingsIcon, // reuse com /configuracoes
} from '@ecx/ui/icons'

const router = useRouter()
// const { t } = useI18n() // reuse com o label de /configuracoes

const sidebarStore = useSidebarStore()
const userStore = useUserStore()
const authStore = useAuthStore()

const { expanded } = storeToRefs(sidebarStore)
const { userName, userEmail, userAvatarUrl } = storeToRefs(userStore)

const toggleSidebar = () => {
  sidebarStore.toggle()
}

const handleSettings = () => {
  router.push('/configuracoes')
}

const handleLogout = () => {
  userStore.clearUser()
  authStore.clearSession()
  authStore.redirectToLogin()
}
</script>
